<script setup lang="ts">
import { ucFirst } from '../../../utils/strings'
import Icon from '../../shared/Icon.vue'

defineProps<{
  diets?: string[]
}>()

const formattedTitle = (diet: string): string => ucFirst(diet)
</script>

<template>
  <div class="bx-recipe__diets">
    <Icon v-for="diet in diets"
          :key="diet"
          :name="diet"
          :title="formattedTitle(diet)" />
  </div>
</template>
